/*=========================================================================================
  File Name: moduleLanguage.js
  Description: Language Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleSurgeryItemState.js'
import mutations from './moduleSurgeryItemMutations.js'
import actions from './moduleSurgeryItemActions.js'
import getters from './moduleSurgeryItemGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations, 
    actions: actions,
    getters: getters
}
